export enum surveyTypes {
    FETCH_SURVEY = 'FETCH_SURVEY',
    FETCH_SURVEY_SUCCESS = 'FETCH_SURVEY_SUCCESS',
    FETCH_SURVEY_FAILED = 'FETCH_SURVEY_FAILED',
    UNMARSHAL_SURVEY_RESPONSE = 'UNMARSHAL_SURVEY_RESPONSE',
    OPEN_MODAL = 'OPEN_MODAL',
    CLOSE_MODALS = 'CLOSE_MODALS',
    OPEN_CONFIRM_MODAL = 'OPEN_CONFIRM_MODAL',
    CLOSE_CONFIRM_MODAL = 'CLOSE_CONFIRM_MODAL',
    DEACTIVATE_SURVEY = 'DEACTIVATE_SURVEY',
    ACTIVATE_SURVEY = 'ACTIVATE_SURVEY',
    SAVE_NEW_SURVEY_ITEM = 'SAVE_NEW_SURVEY_ITEM',
    INSERT_ITEM = 'INSERT_ITEM',
    MOVE_ITEM = 'MOVE_ITEM',
    DELETE_ITEM = 'DELETE_ITEM',
    UNDELETE_ITEM = 'UNDELETE_ITEM',
    CONFIRM_DELETE = 'CONFIRM_DELETE',
    DELETE_NON_DROPPED = 'DELETE_NON_DROPPED',
    OPEN_EDIT_MODAL = 'OPEN_EDIT_MODAL',
    OPEN_DUPLICATE_MODAL = 'OPEN_DUPLICATE_MODAL',
    HANDLE_SURVEY_NOT_FOUND_RESPONSE = 'HANDLE_SURVEY_NOT_FOUND_RESPONSE',
    SET_SURVEY_API = 'SET_SURVEY_API',
    INSERT_NEW_ITEM = 'INSERT_NEW_ITEM'
}